export const SECTIONS = ['allocation', 'performances', 'risk', 'fees']

export function cachedAnalyseBySection({ section, analyses, contractId }) {
  if (section === 'all') {
    if (
      analyses[contractId] &&
      JSON.stringify(Object.keys(analyses[contractId]).sort()) ===
        JSON.stringify(SECTIONS.sort())
    ) {
      return analyses[contractId]
    }
  } else {
    return analyses[contractId] && analyses[contractId][section]
  }
}
